import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {RuteosListComponent} from './ruteos-list.component';
import {RuteosService} from './ruteos.service';
import {IRuteo} from './ruteo';
import * as myGlobals from './../global';
import {Observable} from 'rxjs/Observable';
import {IMerchant} from './merchant';
import {IIssuer} from './issuer';
import {IAccountingNature} from './accountingnature';
import {IServiceInstance} from './serviceinstance';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-ruteo',
  templateUrl: './edit-ruteo.component.html',
  styleUrls: ['./edit-ruteo.component.sass'],
  providers: [RuteosService]
})
export class EditRuteoComponent implements OnInit, OnDestroy, AfterViewInit {
  ruteos: IRuteo[] = [];
  errorMessage = '';
  ruteo: IRuteo;

  merchantSelected: number;
  issuerSelected: string;
  accountingNatureSelected: string;
  serviceInstanceSelected: string;

  merchantList: Observable<IMerchant[]> = this.service.getMerchants();
  issuerList: Observable<IIssuer[]> = this.service.getIssuers();
  accountingNatureList: Observable<IAccountingNature[]> = this.service.getAccountingNatures();
  serviceInstanceList: Observable<IServiceInstance[]> = this.service.getServiceInstances();

  constructor(public service: RuteosService, private parent: RuteosListComponent) {
  }

  ngOnInit() {
    console.log('EditRuteoComponent: OnInit: id: ', this.parent.editnumber);
    this.getRuteo(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=ruteos]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    // RoutingUpdateModel: the routing rule endpoint takes these four fields only.
    const formData = {
      merchantId: this.merchantSelected,
      cardIssuerId: this.issuerSelected,
      accountingNature: this.accountingNatureSelected,
      serviceInstanceId: this.serviceInstanceSelected
    };
    console.log('edit: formData: ', formData);
    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/routing-rule/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function (response) {
      console.log('delete sucess!!');
      window.location.href = '/ruteo';
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar la regla de ruteo: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getRuteo(id: number): any {
    console.log('id: ', id);
    this.service.getRuteo(id).subscribe(
      res => {
        this.ruteo = res;
        this.merchantSelected = res.merchantId;
        this.issuerSelected = res.cardIssuerId;
        this.accountingNatureSelected = res.accountingNature;
        this.serviceInstanceSelected = res.serviceInstanceId;
        console.log('EditRuteoComponent: getRuteo: merchantSelected: [', this.merchantSelected, ']');
        console.log('EditRuteoComponent: getRuteo: issuerSelected: [', this.issuerSelected, ']');
        console.log('EditRuteoComponent: getRuteo: accountingNatureSelected: [', this.accountingNatureSelected, ']');
        console.log('EditRuteoComponent: getRuteo: serviceInstanceSelected: [', this.serviceInstanceSelected, ']');
      },
      error => (this.errorMessage = error as any)
    );
  }

  cancelRuteo(): void {
    this.parent.showRuteos = true;
    this.parent.showAddRuteo = false;
    this.parent.showEditRuteo = false;
  }

  ngOnDestroy() {
  }
}
